import { Controller } from "@hotwired/stimulus"

// Fills the reading-progress bar as the visitor scrolls. Purely cosmetic —
// the page works with this controller entirely absent (the bar just stays
// empty). Progress is measured against the whole document, not the article
// element, so the same controller works on any long page.
export default class extends Controller {
  static targets = ["fill"]

  connect() {
    this.frame = null
    this.onScroll = this.onScroll.bind(this)
    window.addEventListener("scroll", this.onScroll, { passive: true })
    window.addEventListener("resize", this.onScroll)
    this.update()
  }

  disconnect() {
    window.removeEventListener("scroll", this.onScroll)
    window.removeEventListener("resize", this.onScroll)
    if (this.frame) cancelAnimationFrame(this.frame)
  }

  onScroll() {
    if (this.frame) return
    this.frame = requestAnimationFrame(() => {
      this.frame = null
      this.update()
    })
  }

  update() {
    const max = document.documentElement.scrollHeight - window.innerHeight
    const progress = max > 0 ? Math.min(1, Math.max(0, window.scrollY / max)) : 0
    this.fillTarget.style.transform = `scaleX(${progress})`
  }
}
